'use strict';

var React = require('react');
var ClassNames = require('classnames');
var _ = require('lodash');
var Formatter = require('../../utils/Formatter');

var InlineMessage = React.createClass({
    getDefaultProps: function () {
        return {
            type: 'info',
            isHidden: false,
            link: undefined
        };
    },

    propTypes: {
        id: React.PropTypes.string.isRequired,
        type: React.PropTypes.oneOf(['error', 'info', 'errorNoLine', 'infoNoLine']),
        isHidden: React.PropTypes.bool,
        message: React.PropTypes.string,
        customClass: React.PropTypes.string,
        errorClickHandler: React.PropTypes.func
    },

    addEventListener() {
        if (this.props.errorClickHandler){
            var link, elements, message = this.refs.message.children;
            //message - <h4></h4><p></p> or <p></p> or <h4></h4>
            //Check which element has one or more children
            _.forEach(message, function(item){
                if (item.children && item.children.length > 0){
                    elements = item.children;
                    return;
                }
            });
            //attach click listener when there is anchor tag
            _.forEach(elements, function(element){
                if (element.tagName === 'A'){
                    link = element;
                    this.setState({link: link});
                    link.addEventListener('click', this.props.errorClickHandler);
                    //Add href attribute to make it accessible
                    var href = document.createAttribute('href');
                    href.value = 'javascript: void 0;';
                    link.attributes.setNamedItem(href);
                    return;
                }
            }.bind(this));
        }
    },

    componentDidMount: function () {
        this.addEventListener();
    },

    componentWillUnmount: function() {
        if (this.props.errorClickHandler && this.state && this.state.link){
            this.state.link.removeEventListener('click', this.props.errorClickHandler);
        }
    },

    componentDidUpdate: function(prevProps) {
        if (prevProps.message !== this.props.message){
            this.addEventListener();
        }
    },

    render: function () {
        var withHeader = Formatter.hasHtmlHeading(this.props.message);
        return (
                <div key={this.props.key} id={this.props.id} className={ClassNames({'alert': withHeader}, {'contextual-no-header': !withHeader}, this.props.customClass, { hidden: this.props.isHidden }, { 'alert-primary': this.props.type === 'info' && withHeader }, { 'alert-warning': this.props.type === 'error' && withHeader }, { 'alert-warning-no-line': this.props.type === 'errorNoLine' }, { 'alert-primary-no-line': this.props.type === 'infoNoLine' })}>
                    <div ref="message" dangerouslySetInnerHTML={{__html: this.props.message}}></div>
                </div>
        );
    }
});

module.exports = InlineMessage;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/InlineMessage.jsx